const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}


/* Funding counters */
(function () {
	'use strict';

	const FundingCounters = {
		selector: '[data-funding-counter]',
		duration: 2000,

		init(root = document) {
			const counters = root.querySelectorAll(this.selector);
			if (!counters.length) return;

			counters.forEach((counter) => this.setupCounter(counter));
		},

		setupCounter(counter) {
			if (counter.dataset.fundingCounterInitialized === 'true') return;

			const target = this.getTarget(counter);
			if (target === null) return;

			counter.dataset.fundingCounterInitialized = 'true';
			counter.dataset.fundingCounterStarted = 'false';

			if (window.getComputedStyle(counter).display === 'inline') {
				counter.style.display = 'inline-block';
			}
			counter.style.textAlign = 'center';

			this.reserveFinalWidth(counter, target);
			this.renderCounter(counter, 0);
			counter.style.opacity = 0;

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting && counter.dataset.fundingCounterStarted !== 'true') {
							counter.dataset.fundingCounterStarted = 'true';
							this.startCounter(counter);
							observer.unobserve(counter);
						}
					});
				},
				{ threshold: 0 }
			);

			observer.observe(counter);
		},

		getTarget(counter) {
			const targetValue = counter.getAttribute('data-target') || '';
			const target = parseInt(targetValue.replace(/[^\d.-]/g, ''), 10);

			if (Number.isNaN(target)) return null;

			return target;
		},

		startCounter(counter) {
			const target = this.getTarget(counter);
			if (target === null) return;
			if (target <= 0) {
				this.renderCounter(counter, 0);
				counter.style.opacity = 1;
				return;
			}

			const goal = 10000000;

			const intervalTime = 20;
			const duration = parseInt(counter.getAttribute('data-duration') || this.duration, 10) || this.duration;
			const steps = duration / intervalTime;
			const increment = target / steps;

			let current = 0;

			const timer = setInterval(() => {
				current += increment;

				if (current >= target) {
					current = target;
					clearInterval(timer);
				}

				this.renderCounter(counter, Math.floor(current));

				const progress = current / target;
				counter.style.opacity = Math.min(progress, 1);

			}, intervalTime);

			const progressBar = counter.id === 'header-funding-counter' ? document.getElementById('ls-progress-bar') : null;
			if (progressBar && target > 0) {
				const progress = (target / goal) * 100;
				setTimeout(() => {
					progressBar.style.width = `${progress}%`;
				}, 300);
			}
		},

		renderCounter(counter, value) {
			const prefix = counter.getAttribute('data-prefix') || '';
			const prefixClass = counter.getAttribute('data-prefix-class') || '';
			const formattedValue = value.toLocaleString('en-US');

			counter.textContent = '';

			if (prefix) {
				if (prefixClass) {
					const prefixEl = document.createElement('span');
					prefixEl.className = prefixClass;
					prefixEl.textContent = prefix;
					counter.appendChild(prefixEl);
				} else {
					counter.appendChild(document.createTextNode(prefix));
				}
			}

			counter.appendChild(document.createTextNode(formattedValue));
		},

		reserveFinalWidth(counter, target) {
			const previousHtml = counter.innerHTML;
			const previousMinWidth = counter.style.minWidth;

			this.renderCounter(counter, target);
			counter.style.minWidth = '';
			const finalWidth = counter.getBoundingClientRect().width;

			counter.innerHTML = previousHtml;

			if (finalWidth > 0) {
				counter.style.minWidth = `${finalWidth}px`;
			} else {
				counter.style.minWidth = previousMinWidth;
			}
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => FundingCounters.init());
	} else {
		FundingCounters.init();
	}

	if (Shopify.designMode) {
		document.addEventListener('shopify:section:load', (event) => FundingCounters.init(event.target));
	}

})();

/* Header announcement scroll */
(function () {
  'use strict';

  function checkAnnouncementOverflow() {
    const standard = document.querySelector('.utility-bar--standard');
    const marqueeWrapper = document.querySelector('.utility-bar--marquee');
    const center = document.querySelector('.utility-bar__center');
    const message = center ? center.querySelector('.announcement-bar__message') : null;

    if (!standard || !marqueeWrapper || !center || !message) return;

    if (message.scrollWidth > center.offsetWidth) {
      if (!marqueeWrapper.hasChildNodes()) {
        const track = document.createElement('div');
        track.classList.add('utility-bar-marquee__track');

        for (let i = 0; i < 2; i++) {
          const clone = standard.cloneNode(true);
          clone.style.display = 'flex';
          clone.style.flexShrink = '0';
          track.appendChild(clone);
        }

        marqueeWrapper.appendChild(track);
      }

      standard.style.display = 'none';
      marqueeWrapper.style.display = 'block';
    } else {
      standard.style.display = '';
      marqueeWrapper.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAnnouncementOverflow);
  } else {
    checkAnnouncementOverflow();
  }

  window.addEventListener('resize', checkAnnouncementOverflow);

})();
